import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { productGalleryContent } from '../../../../cloudinary';

export default class Image360Carousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVideoDisplayed: false,
      isSingleImage: false,
    };
    this.onVideoSelected = this.onVideoSelected.bind(this);
  }

  componentDidMount() {
    // check to see if we have one image and that image contains http - hence a reverse proxy image
    if (this.props.images.length === 1 && this.props.images[0].largeImageURL.indexOf('http') > -1) {
      this.setState({
        isSingleImage: true,
      });
    } else {
      const localMediaAssets = [];

      this.props.images.forEach(image => {
        localMediaAssets.push(
          { publicId: image.thumbnailURL.substring(image.thumbnailURL.lastIndexOf('/') + 1).replace('.jpg', ''), mediaType: 'image' },
        );
      });

      if (this.props.is360Display) {
        localMediaAssets.push({ tag: this.props.productNumber, mediaType: 'spin' });
      }

      productGalleryContent.mediaAssets = localMediaAssets;
      productGalleryContent.cloudName = this.props.productGalleryContentCloudName;

      if (localMediaAssets.length > 0) {
        const productGallery = window.cloudinary.galleryWidget(productGalleryContent);
        productGallery.render();

        productGallery.on('thumbclick', () => {
          this.setState({
            isVideoDisplayed: false,
          });
        });
      }
    }
  }

  onVideoSelected() {
    this.setState({
      isVideoDisplayed: true,
    });
  }

  render() {
    return (
      <div className="images">

        {this.props.images.length > 0 && !this.state.isSingleImage &&
          <div
            id="productGallery"
            className={`${this.props.vfmFlagImages.length === 0 ? 'product-gallery product-gallery-full' : 'product-gallery'}`}
          />
        }

        {this.props.vfmFlagImages.length > 0 &&
          <div className="vfm-flags-images-container">
            { this.props.vfmFlagImages.map(({ id, imageURL, hoverText, imageName }) =>
              (<span key={id}>
                <img
                  className="vfm-flags-image"
                  src={imageURL}
                  title={hoverText}
                  alt={imageName}
                />
              </span>),
            )}
          </div>
        }

        {this.state.isSingleImage &&
          <img id="mainImage" src={this.props.images[0].largeImageURL} alt="Main Product" />
        }

        <div className={classNames({
          'image-content-padding-left ': this.props.images.length > 0 && !this.state.isSingleImage,
          'vfm-content-padding-right ': this.props.vfmFlagImages.length > 0,
        })}
        >
          {this.props.shared.isShared &&
          <div className="supporting-text">{this.props.shared.sharedMessage}</div>
          }

          <div className="viewer-3d-video-container">
            {this.props.video.videoURL &&
              <div
                className="video-container video-container"
                onClick={this.onVideoSelected}
                role="button"
                tabIndex={-1}
              >
                <span className="video">
                  <img
                    className="video-image"
                    src={this.props.video.thumbnailURL}
                    alt=""
                  />
                </span>
              </div>
            }
          </div>
        </div>

        {this.state.isVideoDisplayed &&
          <div className={`${this.props.vfmFlagImages.length === 0 ? 'video-3d-content video-3d-content-full' : 'video-3d-content'}`}>
            <iframe
              title={this.props.video.videoURL}
              id={'mainVideo'}
              className="main-video-3d-viewer"
              src={this.props.video.videoURL}
              frameBorder="0"
              wmode="opaque"
            />
          </div>
        }

      </div>
    );
  }
}
Image360Carousel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    thumbnailURL: PropTypes.string.isRequired,
    largeImageURL: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  })).isRequired,
  shared: PropTypes.shape({
    isShared: PropTypes.bool.isRequired,
    sharedMessage: PropTypes.string.isRequired,
  }).isRequired,
  video: PropTypes.shape({
    thumbnailURL: PropTypes.string,
    videoURL: PropTypes.string,
  }).isRequired,
  vfmFlagImages: PropTypes.arrayOf(PropTypes.shape({
    imageURL: PropTypes.string.isRequired,
    imageName: PropTypes.string.isRequired,
    hoverText: PropTypes.string.isRequired,
  })).isRequired,
  is360Display: PropTypes.bool.isRequired,
  productGalleryContentCloudName: PropTypes.string.isRequired,
  productNumber: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/Image360Carousel/Image360Carousel.js